import { NewsItemModel } from '../../../../api-service/clients';

export function isStillVisible(newsItem: NewsItemModel) {
  if (!newsItem.expirationDate) {
    return true;
  }

  // "Synlig til og med" includes the expiry date itself, so compare against the end of that day.
  const endOfExpiryDay = new Date(newsItem.expirationDate);
  endOfExpiryDay.setHours(23, 59, 59, 999);

  return endOfExpiryDay >= new Date();
}
